/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import { useMeusKits } from '../../contexts/MeusKitsContext'
import styled from 'styled-components'
import InlineLoader from '../../components/InlineLoader/InlineLoader'
import { MEUS_KITS_TITULO } from './constants'
import Pedido from './components/Pedido'
import Filter from './components/Filter'
import { MessageCombo } from '../../components/MessageCombo'
import { ReactComponent as LogoCuradoriaIcon } from '../../assets/icons/Logo_curadoria.svg'
import { ReactComponent as LogoIneditosIcon } from '../../assets/icons/logo_ineditos.svg'
import useEnvioUnico from '../../hooks/useEnvioUnico'

const textComboEnvioUnico = 'Agora você faz parte do envio unificado da TAG! Seus kits (Curadoria e Inéditos) serão enviados juntos, em uma única entrega.'
const Titulo = styled.h1`
  ${StyleGuide.tipografia.titulo1};
  margin: 25px 0 22px 0;
`

const Header = styled.div`
  display: flex;
  .first-row {
    @media (max-width: 520px) {
      flex-direction: column;
    }
    width: 100%;
    max-width: ${( { both } ) => ( both ? '800px' : '385px' )};
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
  padding-bottom: 20px;
`
const Card = styled.div`
  background: #ffffff;
  padding: 0 16px 16px 16px;
  width: 385px;
  box-shadow: 0px 1px 4px rgba(19, 26, 45, 0.2);
  border-radius: 16px;
  height: 100%;
  > p {
    color: ${( { color } ) => color};
    text-align: center;
  }
  h2 {
    padding: 15px 0 0 15px;
  }
  .header {
    display: flex;
  }
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    width: calc(100vw - 50px);
  }
  @media (min-width: 521px) {
    width: 70%;
    max-width: 385px;
  }
  @media (min-width: 1000px) {
    width: 385px;
  }
`

const Line = styled.div`
  border: 1px solid #efefef;
  width: 100%;
`


const CardsModalidade = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    flex-direction: column;
  }
  p {
    cursor: pointer;
    font-family: "Noto Sans Display", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    text-decoration-line: underline;
  }
`

const MeusKitsContainer = styled.div`
`

function MeusKits() {
  const { buscarDadosPedido, dadosMeusKits, detalhePedido, listarPedidos } = useMeusKits()

  const [ filters, setFilters ] = useState( {} )
  const [ loadingDetalhes, setLoadingDetalhes ] = useState( false )
  const [ modalidade, setModalidade ] = useState( {} )
  const [ expanded, setExpanded ] = useState( false )
  const [ verMaisIneditos, setVerMaisIneditos ] = useState( false )
  const [ verMaisCuradoria, setVerMaisCuradoria ] = useState( false )
  const [ isEnvioUnico ] = useEnvioUnico( dadosMeusKits )

  const { isMobile } = StyleGuide

  useEffect( () => {
    listarPedidos()
  }, [] )

  async function getDadadosPedido( id ) {
    setLoadingDetalhes( true )
    await buscarDadosPedido( id )

    setLoadingDetalhes( false )
  }

  useEffect( () => {
    const hasIneditos = dadosMeusKits.find( kit => kit.modalidade === 'Inéditos' )
    const hasCuradoria = dadosMeusKits.find( kit => kit.modalidade === 'Curadoria' )
    if ( hasCuradoria && hasIneditos ) {
      setModalidade( 'both' )
    } else if ( hasIneditos ) {
      setModalidade( 'ineditos' )
    } else {
      setModalidade( 'curadoria' )
    }
  }, [ dadosMeusKits ] )


  const byAno = item => !filters.ano ? true : item.anoTag === Number( filters.ano )
  const byStatus = item => {
    if ( filters.status ) {
      if (
        filters.status === 'PAGO' &&
        ( item.status === 'COBRADO' || item.statusEnvio === 'ENTREGUE' )
      ) {
        return true
      }

      if (
        filters.status === 'ESTORNADO' &&
        ( item.status === 'ESTORNADO' || item.status === 'ESTORNO_PARCIAL' ) &&
        item.statusEnvio !== 'ENTREGUE'
      ) {
        return true
      }
      return item.status === filters.status
    }
    return true
  }

  function handleExpanded( index ) {
    if ( expanded === index ) {
      setExpanded( null )
    } else {
      setExpanded( index )
    }
  }

  function isExpanded( index ) {
    if ( expanded === index ) {
      return true
    }
    return false
  }

  function sortById( kit1, kit2 ) {
    if ( kit1.id > kit2.id ) {
      return -1
    }
    if ( kit1.id < kit2.id ) {
      return 1
    }
    return 0
  }

  function renderItems( modalidadeName, stateVerMais, color ) {
    return dadosMeusKits
      .filter( byAno )
      .filter( byStatus )
      .filter( kit => kit.modalidade === modalidadeName )
      .filter( kit => !kit.isReenvio )
      .sort( sortById )
      .map( ( pedido, index ) => {
        const maxRender = isMobile() ? 3 : 6
        return index < maxRender || stateVerMais ? (
          <>
            <Pedido
              color={ color }
              detalhePedido={ detalhePedido }
              getDadadosPedido={ getDadadosPedido }
              handleExpanded={ () => handleExpanded( `${index}-${modalidadeName}` ) }
              isExpanded={ () => isExpanded( `${index}-${modalidadeName}` ) }
              key={ pedido.id }
              loadingDetalhes={ loadingDetalhes }
              pedido={ pedido }
            />

            <Line />
          </>
        ) : null
      } )
      .filter( kit => kit )
  }

  function renderIneditoCard() {
    return (
      <Card color="#EB8100">
        <div className="header">
          <LogoIneditosIcon />

          <h2>TAG Inéditos</h2>
        </div>

        {kitsIneditos}

        {renderPtodoOsPedidos( kitsIneditos.length ) && (
          <p onClick={ () => setVerMaisIneditos( !verMaisIneditos ) }>
            {verMaisIneditos ? 'Voltar' : 'Ver todos os pedidos'}
          </p>
        )}
      </Card>
    )
  }

  function renderCuradoriaCard() {
    return (
      <Card color="#009BBF">
        <div className="header">
          <LogoCuradoriaIcon />

          <h2>TAG Curadoria</h2>
        </div>

        {kitsCuradoria}

        {renderPtodoOsPedidos( kitsCuradoria.length ) && (
          <p onClick={ () => setVerMaisCuradoria( !verMaisCuradoria ) }>
            {verMaisCuradoria ? 'Voltar' : 'Ver todos os pedidos'}
          </p>
        )}
      </Card>
    )
  }

  const kitsIneditos = renderItems( 'Inéditos', verMaisIneditos, '#EB8100' )
  const kitsCuradoria = renderItems( 'Curadoria', verMaisCuradoria, '#009BBF' )

  function renderPtodoOsPedidos( kitsLength ) {
    if ( isMobile() && kitsLength >= 3 ) {
      return true
    }
    if ( !isMobile() && kitsLength >= 6 ) {
      return true
    }
    return false
  }

  return (
    <MeusKitsContainer modalidade={ modalidade }>
      {dadosMeusKits.length > 0 ? (
        <>
          <Header
            both={ modalidade === 'both' }
            className="flex-col max-width"
          >
            <div className="flex-row first-row">
              <Titulo>{MEUS_KITS_TITULO}</Titulo>

              <div className="item-center ">
                <Filter setFilter={ setFilters } />
              </div>
            </div>

            {isEnvioUnico ?
              <MessageCombo
                maxWidth="800px"
                text={ textComboEnvioUnico }
              /> : null}
          </Header>

          <CardsModalidade>
            {modalidade === 'both' && (
              <>
                {renderCuradoriaCard()}

                {renderIneditoCard()}
              </>
            )}

            {modalidade === 'curadoria' && <>{renderCuradoriaCard()}</>}

            {modalidade === 'ineditos' && <>{renderIneditoCard()}</>}
          </CardsModalidade>
        </>
      ) : (
        <InlineLoader isCenter />
      )}
    </MeusKitsContainer>
  )
}

export default MeusKits
